import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLocale } from '@/contexts/LocaleContext';
import { 
  Home,
  Search,
  Sparkles,
  Zap,
  Store
} from 'lucide-react';

const MobileBottomNav = ({ unreadCount = 0 }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { isUSA } = useLocale();

  // Only show for authenticated users
  if (!isAuthenticated) return null;

  const navItems = [
    { to: '/dashboard', icon: Home, label: isUSA ? 'Home' : 'Inicio', testId: 'bottom-nav-home' },
    { to: '/search', icon: Search, label: isUSA ? 'Search' : 'Buscar', testId: 'bottom-nav-search' },
    { to: '/dashboard/store', icon: Store, label: isUSA ? 'Store' : 'Tienda', testId: 'bottom-nav-store' },
    { to: '/dashboard/texvision', icon: Sparkles, label: 'TexHub AI', testId: 'bottom-nav-texhub-ai', highlight: true },
    { to: '/surplus', icon: Zap, label: isUSA ? 'Surplus' : 'Saldos', testId: 'bottom-nav-surplus' },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') return location.pathname === '/dashboard';
    if (path === '/search') return location.pathname === '/search';
    if (path === '/dashboard/store') return location.pathname === '/dashboard/store';
    return location.pathname.includes(path.replace('/dashboard', ''));
  };

  return (
    <nav className="mobile-bottom-nav lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 safe-area-bottom" style={{ zIndex: 9999 }}>
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors relative ${
              isActive(item.to) 
                ? item.highlight ? 'text-amber-600' : 'text-[#1E4C8E]'
                : item.highlight ? 'text-amber-500 hover:text-amber-600' : 'text-slate-400 hover:text-slate-600'
            }`}
            data-testid={item.testId}
          >
            <item.icon className={`w-5 h-5 ${item.highlight ? 'animate-pulse' : ''}`} />
            {item.badge > 0 && (
              <span 
                className="absolute top-2 right-1/4 w-4 h-4 text-[10px] font-bold text-white rounded-full flex items-center justify-center"
                style={{ backgroundColor: '#34B772' }}
              >
                {item.badge > 9 ? '9+' : item.badge}
              </span>
            )}
            <span className={`text-xs mt-1 font-medium ${item.highlight ? 'font-bold' : ''}`}>{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
